<template>
    <div class="login">
        <div class="login-content">
            <!-- <img src="assets/layout/images/site-logo-WN.svg" alt="Wealth Net &reg;"/> -->
            <div class="p-grid p-col-12">
                <div class="p-col-12">
                    <div class="p-col-12">
                        <img class="login-logo" src="assets/layout/images/logo.png" alt="MC Bot">
                    </div>
                    <div class="login-content-main p-col-12">
                        <div class="login-header">
                            <h1>Login</h1>
                            <Button @click="register('register')" label="Register" />
                        </div>
                        <div class="login-body">
                            <div class="form-item">
                                <label for="user-email">Email</label>
                                <InputText id="user-email"
                                           placeholder="Email"
                                           v-model="email"
                                           label="Email" />
                            </div>
                            <div class="form-item form-item-password">
                                <div class="form-item-top">
                                    <label for="user-pass">Password</label>
                                    <a href="#" @click="forgotPassword()">Forgot Password?</a>
                                </div>
                                <Password id="user-pass"
                                          @keyup.enter="login()"
                                          placeholder="Password"
                                          v-model="password"
                                          :feedback="false" />
                            </div>
                            <p></p>
                            <div class="form-action">
                                <Button @click="login()" label="Login" />
                            </div>
                            <div class="form-action">
                                <Button @click="showcase()" label="Showcase" style="margin-top:25px" />
                            </div>

                        </div>
                        <Toast />
                    </div>
                </div>
             
            </div>
        </div>
    </div>
</template>

<script>
    import LoginService from "../service/LoginService.js";

    // export default {
    //     data() {
    //         return {
    //             email: null,
    //             password: null,
    //             refid: null,
    //             token: null
    //         };
    //     },
    //     created() {
    //         this.loginService = new LoginService();
    //         this.refid = this.$route.query.refid;
    //         if (this.$route.query.token) {
    //             this.login()
    //         }
    //     },
    //     methods: {
    //         async login() {
    //             try {
    //                 if (this.$route.query.token) {
    //                     console.log(this.$route.query)
    //                     console.log('params')
    //                     console.log(this.$route.params.token)
    //                     this.token = this.$route.query.token
    //                 }
    //                 else {
    //                     this.token = await this.loginService.getToken(
    //                         this.email,
    //                         this.password)
    //                 }

    export default {
        data() {
            return {
                email: null,
                password: null,
                refid: null,
                token: null,
            };
        },
        created() {
            this.loginService = new LoginService();
            this.refid = this.$route.query.refid;
            if (this.$route.query.token) {
                this.login();
            }
        },
        methods: {
            async login() {
                await this.$recaptchaLoaded();
                const captchaToken = await this.$recaptcha("login");
                //const captchaToken = 'drek';
                //console.log(captchaToken);

                try {
                    if (this.$route.query.token) {
                        //   console.log(this.$route.query);
                        //   console.log("params");
                        //   console.log(this.$route.params.token);
                        this.token = this.$route.query.token;
                    } else {
                        this.token = await this.loginService.getToken(
                            this.email,
                            this.password,
                            captchaToken
                        );
                    }

                    /*if (token === 400){ //refactor
                                        this.$toast.add({severity:'error', summary: 'wrong username or password', detail:'Validation failed', life: 3000, position: "topleft"});

                                        return
                                    }*/
                    const data = await this.loginService.getUser(this.token);

                    //this.$route.params.email;
                    //this.$route.params.password;
                    console.log(data);

                    this.$store.commit("logIn", {
                        id: data.id,
                        username: data.username,
                        name: data.name,
                        surname: data.surname,
                        role: data.role,
                        email: data.email,
                        first_name: data.name,
                        last_name: data.surname,
                        date_of_birth: data.date_of_birth,
                        phone: data.phone,
                        address: data.address,
                        zip: data.zip,
                        city: data.city,
                        country: data.country,
                        account_name: data.account_name,
                        account_number: data.account_number,
                        account_signatory_person: data.account_signatory_person,
                        swift: data.swift,
                        bic: data.bic,
                        iban: data.iban,
                        btc_wallet: data.btc_wallet,
                        bank_name: data.bank_name,
                        bank_address: data.bank_address,
                        bank_zip: data.bank_zip,
                        bank_city: data.bank_city,
                        bank_country: data.bank_country,
                        company_id: data.company_id,
                        company: data.company,
                        company_name: data.company_name,
                        left_id: data.left_id,
                        right_id: data.right_id,
                        rotation_left: data.rotation_left,
                        rotation_right: data.rotation_right,
                        token: this.token,
                    });
                } catch (error) {
                    if (error.message === "403")
                        this.$router.push({
                            name: "emailnotverified",
                            params: { email: this.email },
                        });
                    return;
                }
            },

            async forgotPassword() {
                this.$router.push({
                    name: "forgotpassword",
                    params: { email: this.email },
                });
            },

            register() {
                this.$router.push("register");
            },
            async showcase() {
                await this.$recaptchaLoaded();
                const captchaToken = await this.$recaptcha("login");
                //const captchaToken = 'drek';
                //console.log(captchaToken);

                try {
                    if (this.$route.query.token) {
                        //   console.log(this.$route.query);
                        //   console.log("params");
                        //   console.log(this.$route.params.token);
                        this.token = this.$route.query.token;
                    } else {
                        this.token = await this.loginService.getToken(
                           'showcase@showcase.com',
                            'showcase',
                            captchaToken
                        );
                    }

                    /*if (token === 400){ //refactor
                                        this.$toast.add({severity:'error', summary: 'wrong username or password', detail:'Validation failed', life: 3000, position: "topleft"});

                                        return
                                    }*/
                    const data = await this.loginService.getUser(this.token);

                    //this.$route.params.email;
                    //this.$route.params.password;
                    console.log(data);

                    this.$store.commit("logIn", {
                        id: data.id,
                        username: data.username,
                        name: data.name,
                        surname: data.surname,
                        role: data.role,
                        email: data.email,
                        first_name: data.name,
                        last_name: data.surname,
                        date_of_birth: data.date_of_birth,
                        phone: data.phone,
                        address: data.address,
                        zip: data.zip,
                        city: data.city,
                        country: data.country,
                        account_name: data.account_name,
                        account_number: data.account_number,
                        account_signatory_person: data.account_signatory_person,
                        swift: data.swift,
                        bic: data.bic,
                        iban: data.iban,
                        btc_wallet: data.btc_wallet,
                        bank_name: data.bank_name,
                        bank_address: data.bank_address,
                        bank_zip: data.bank_zip,
                        bank_city: data.bank_city,
                        bank_country: data.bank_country,
                        company_id: data.company_id,
                        company: data.company,
                        company_name: data.company_name,
                        left_id: data.left_id,
                        right_id: data.right_id,
                        rotation_left: data.rotation_left,
                        rotation_right: data.rotation_right,
                        token: this.token,
                    });
                } catch (error) {
                    if (error.message === "403")
                        this.$router.push({
                            name: "emailnotverified",
                            params: { email: this.email },
                        });
                    return;
                }
            },
        },
    };
</script>

<style scoped>
</style>